export default "__VITE_ASSET__CiFKQLvg__"